import React, { useEffect, useState } from "react";
import { Reorder, motion, useDragControls } from "framer-motion";
import Wrapper, { wrapperTypes } from "global/wrappers/Wrapper";
import UiSaveButtons from "global/components/buttons/UiSaveButtons";
import { Icon, Label } from "semantic-ui-react";
import _ from "lodash";
import { _imsTypes } from "global/wrappers/ItemMenuSquares";

// const initialIcons = [
//   { key: "1", caption: "📅 Schedule" },
//   { key: "2", caption: "📊 Stats" },
//   { key: "3", caption: "⚙️ Settings" },
//   { key: "4", caption: "🧭 Map" },
//   { key: "5", caption: "📨 Messages" },
// ];

const _isInline = true

export default function SortableGrid({
  allowReorder,
  divFn, // function used to fill the content
  groupKey = 'gk1',
  handleSorted,
  handleSelect,
  imsType,
  items,
  onSort,
  showApply,
  showReorder,
  sortProp,
  headerProp = 'propSection',
  ignoreSort,
}) {

  const [currentItems, setCurrentItems] = useState([]);
  const [isSortMode, setIsSortMode] = useState();
  const [allowSortUpdate, setAllowSortUpdate] = useState()
  const [draggingKey, setDraggingKey] = useState(null);
  const [hasFirstItemLogic, setHasFirstItemLogic] = useState()

  let useFn = divFn ? true : false;

  switch (imsType) {
    case _imsTypes.sortSelect:
      useFn = false
      break;
    default:
    // nothing
  }

  useEffect(() => {
    if (items) {
      const _items = _.cloneDeep(items)
      const _items_sorted = ignoreSort ? _items : _.sortBy(_items, sortProp || 'position')
      const _currentItems = _.map(_items_sorted, item => item)
      const hasFirstItemLogic = _.some(_currentItems, '_isFirstItem')
      setCurrentItems(_currentItems)
      setHasFirstItemLogic(hasFirstItemLogic)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useEffect(() => {
    setIsSortMode(showReorder)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showReorder]);

  const handleSortUpdate = () => {
    setAllowSortUpdate(false)
    handleSorted(currentItems)
  }


  const handleApplyDefault = () => {
    const nameOrder = ['name', 'details', 'schedule', 'contact', 'address', 'location', 'description']
    const orderMap = _.zipObject(
      nameOrder,
      _.range(nameOrder.length)
    )

    const sorted = _.map(
      _.sortBy(currentItems, item => orderMap[item.key] ?? Number.MAX_SAFE_INTEGER),
      (item, position) => ({
        ...item,
        position
      })
    )
    handleSorted(sorted)
  }

  const handleReorder_items = (itemz) => {
    setAllowSortUpdate(true)
    if (hasFirstItemLogic) {
      const _items = normalizeSections(itemz, headerProp)
      setCurrentItems(_items)
      if (onSort) { onSort(_items) }
    } else {
      setCurrentItems(itemz)
      if (onSort) { onSort(itemz) }
    }
  }



  const footer_reorder = () => {
    const btns = []
    btns.push({ oc: handleSortUpdate, color: 'blue', caption: 'Apply Sort Changes', icon: 'arrow right', disabled: !allowSortUpdate })
    btns.push({ oc: handleApplyDefault, color: 'blue', caption: 'Apply Defaults', icon: 'arrow right', fl: true })
    return <UiSaveButtons others={btns} />
  }

  return (
    <Wrapper
      wrapperType={wrapperTypes.paddedFooter}
      noMid={true}
      footer={allowReorder && showApply && !onSort && footer_reorder()}

      content={<Reorder.Group
        key={groupKey}
        as={motion.div}
        axis="y"
        values={currentItems}
        style={{ userSelect: draggingKey ? 'none' : 'auto' }}
        onReorder={handleReorder_items}
      >
        {currentItems.map((item, index) => (
          // divFn && useFn && !showReorder ? divFn(item, item.key) :
          <SortableItem
            key={item.key || item._itemKey}
            groupKey={groupKey}
            item={item}
            index={index}
            isSortMode={isSortMode}
            showReorder={showReorder}
            draggingKey={draggingKey}
            setDraggingKey={setDraggingKey}
            imsType={imsType}
            handleSelect={handleSelect}
            divFn={divFn} // used to fill the content of the sortable item
            useFn={useFn}
            headerProp={headerProp}
          >
          </SortableItem>
        ))}
      </Reorder.Group>}
    >
    </Wrapper >
  );
}

/* 👇 NEW COMPONENT (required for hooks) */
const SortableItem = ({
  item,
  index,
  isSortMode,
  showReorder,
  draggingKey,
  setDraggingKey,
  imsType,
  handleSelect,
  groupKey,
  divFn, // passed in from the parent
  useFn,
  headerProp,
  children,
}) => {

  const controls = useDragControls();

  const handle_click = (e) => {
    handleSelect && !showReorder && handleSelect(item, { key: groupKey })
  }

  const { position, seed, text, value, key, caption, name, selected, display } = item ?? {}
  const { caption: caption_display } = display ?? {}

  const _index = position || seed || index
  let _caption = text || caption_display || caption || name || value || key

  if (caption_display && _.camelCase(caption_display) !== key) {
    _caption = `${caption_display} (${_.startCase(key)})`
  }

  let useHandle;

  switch (imsType) {
    case _imsTypes.sortSelect:
      useHandle = true
      break;
    default:
      useHandle = true
    // nothing
  }

  let cn = `imsc-item ${!useHandle ? 'ndr' : 'dr'} ${item.key === draggingKey ? 'drg' : ''} ${selected ? 'sel' : ''}`

  if (item._isFirstItem) { cn += ' sh' }

  const div_item = () => {
    if (divFn && useFn) {
      return divFn(item, item.key, controls)
    }
    if (item._isFirstItem) {
      return <div className="sqr-box fi"><div className='imsc-item-header'>
        <Icon name={'object ungroup outline'}
          color={'blue'}
          style={{ marginRight: '1em' }}
        />
        {_.startCase(item?.[headerProp])}
      </div></div>
    } else {
      return <div className="sqr-box si">
        <Label
          className="sqr-box-icon"
          color={'blue'}
          size='mini'
          style={useHandle ? { cursor: 'grab' } : {}}
          onPointerDownCapture={(e) => { if (useHandle) controls.start(e) }}
        >
          {_index + 1}
        </Label>
        <div>
          {_caption || '???'}
        </div>
      </div>
    }

  }

  return (
    <Reorder.Item
      as={motion.div}
      className={divFn && useFn ? null : cn}
      drag={(!item._isFirstItem && isSortMode) || useHandle}
      dragControls={useHandle ? controls : undefined} // 👈 toggle 
      dragListener={!useHandle} // 👈 toggle
      onClick={handleSelect && handle_click}
      onDragEnd={() => setDraggingKey(null)}
      onDragStart={() => setDraggingKey(item.key)}
      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
      value={item}
      onPointerDown={(e) => {
        if ((!item._isFirstItem && isSortMode) || useHandle) {
          e.preventDefault(); // 🔑 stops text highlight
        }
      }}
    >
      {div_item()}
    </Reorder.Item>
  );
};

const normalizeSections = (items, headerProp) => {
  const _items = _.cloneDeep(items);

  let currentSection = null;
  let position = 0

  _.forEach(_items, (item) => {
    if (item._isFirstItem) {
      currentSection = item[headerProp];
      position = 0
    } else {
      item[headerProp] = currentSection;
      item.position = position
      position++
    }
  });

  return _items;
}; 
